import { render, staticRenderFns } from "./local-case-validation-situations-grid.vue?vue&type=template&id=15e1074b&scoped=true&"
import script from "./local-case-validation-situations-grid.ts?vue&type=script&lang=ts&"
export * from "./local-case-validation-situations-grid.ts?vue&type=script&lang=ts&"
import style0 from "./local-case-validation-situations-grid.scss?vue&type=style&index=0&id=15e1074b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e1074b",
  null
  
)

export default component.exports